export const AUTH = 'auth';

export const EVENTS_LIST = 'events/list';
export const EVENTS_SCAN = 'events/scan';

export const FAST_SCAN = 'fast/scan';
